var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "accordion" },
    _vm._l(_vm.items, function(item) {
      return _c(
        "ui-accordion-item",
        {
          key: item.key,
          attrs: {
            "item-key": item.key,
            title: item.title,
            content: item.description,
            "not-extendable": !_vm.extendable
          },
          nativeOn: {
            click: function($event) {
              return _vm.$emit("item-click", item.key)
            }
          },
          scopedSlots: _vm._u(
            [
              {
                key: "title",
                fn: function() {
                  return [_vm._t("title", null, { data: item })]
                },
                proxy: true
              }
            ],
            null,
            true
          )
        },
        [_vm._t("default", null, { data: item })],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }